import Commands from './commands';

class SMembers extends Commands {
    constructor(registry) {
        super("sMembers", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        const container = this.registry.get(key);
        if (!container) {
            throw "Set not found";
        }
        return Array.from(container);
    }
}

export default SMembers;
